import { Alert, type SxProps, type Theme } from "@mui/material";
import type { SystemFailureNotice } from "../utils/systemFailure";

interface SystemFailureAlertProps {
  notice: SystemFailureNotice | null | undefined;
  sx?: SxProps<Theme>;
}

/** Single markup for the OCR_FAILED / D365_FAILED notice, shared by the detail page and review modal. */
export default function SystemFailureAlert({ notice, sx }: SystemFailureAlertProps) {
  if (!notice) return null;
  return (
    <Alert severity="error" sx={[{ wordBreak: "break-word" }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <strong>{notice.title}:</strong> {notice.reason}
    </Alert>
  );
}
